import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { useFetchContentQuery } from "store/services/user.service";
import Loader from "components/shared/Loader";
import logo from "../Assets/images/logo.png";

const TermsConditions = () => {
  const { data: termsContent, isLoading, error } = useFetchContentQuery("TERMS_CONDITIONS");
  const [content, setContent] = useState("");

  useEffect(() => {
    if (termsContent) {
      setContent(termsContent.content);
    }
  }, [termsContent]);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    toast.error("Error loading content");
  }

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="formInner text-center">
        <div className="py-4">
          <img src={logo} alt="Project Logo" className="mb-4" style={{ height: "60px" }} />
          <h2 className="m-0 fw-sbold head">Terms and Conditions</h2>
        </div>
        <div className="inner">
          <Row>
            <Col lg="12" className="my-2">
              <div className="contentSec">
                <div
                  className="m-0 text-muted py-2"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
